exports = module.exports = require("../../../../../deck/node_modules/.pnpm/css-loader@2.1.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".canary-config-section .col-md-6,\n.canary-config-section .col-md-8 {\n  margin-top: 5px;\n}\n", ""]);

